'use client'
import { CMSLink } from '@/components/Link'
import { Media } from '@/components/Media'
import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'
import RichText from '@/components/RichText'

const StyleListServiceCard = ({
  service,
  cardStyle,
  iconPosition = 'left',
  imageStyle = 'rounded',
  imagePadding = 'normal',
  imageClassName,
  cardClassName,
  btnClassName,
}: {
  service: any
  cardStyle?: 'normal' | 'padding'
  iconPosition?: 'left' | 'right'
  imageStyle?: 'rounded' | 'normal'
  imagePadding?: 'normal' | 'padding'
  imageClassName?: string
  cardClassName?: string
  btnClassName?: string
}) => {
  return (
    <div className="group hover:transition-all hover:ease-linear hover:duration-300 h-full flex flex-col">
      <div className="relative block">
        <div
          className={cn(
            'relative block overflow-hidden rounded-none ',
            {
              'picture-rounded': imageStyle === 'rounded',
              'mx-[30px]': imagePadding === 'padding',
            },
            imageClassName,
          )}
        >
          <Media
            resource={service?.image}
            imgClassName={cn(
              'w-full h-[35vh] object-cover transform scale-100 transition-transform duration-1000 ease-in-out group-hover:scale-110 group-hover:rounded-xl',
              {
                'rounded-none': cardStyle === 'normal',
              },
            )}
          />
          <div className="absolute top-0 bottom-0 left-1/2 right-[51%] bg-secondary opacity-20 pointer-events-none transition-all duration-[400ms] ease-linear group-hover:left-0 group-hover:right-0"></div>
        </div>
      </div>
      <div
        className={cn(
          'relative mx-[15px] md:mx-[30px] mt-[-10px] bg-card rounded-[20px] px-[30px] pt-[20px] pb-[20px] flex-1 flex flex-col',
          {
            'mt-0 mx-0 rounded-none pt-[20px]': cardStyle === 'normal',
          },
          cardClassName,
        )}
      >
        {service?.icon && (
          <div
            className={cn(
              'absolute top-[-40px] left-0 flex items-center justify-center w-[80px] h-[80px] bg-secondary rounded-full z-[1]',
              {
                'left-[75%] ': iconPosition === 'right',
              },
            )}
          >
            <div className="absolute inset-0 rounded-full bg-primary scale-0 transition-transform duration-400 z-[-1] group-hover:scale-100 [transition-timing-function:cubic-bezier(0.62,0.21,0.45,1.52)]"></div>
            <span className="relative inline-block text-[38px] transition-all duration-[500ms] delay-[100ms] scale-100">
              {' '}
              <Media resource={service?.icon} className="w-full h-full" />
            </span>
          </div>
        )}

        {/* Title */}
        {service?.title && (
          <RichText
            data={service.title}
            enableGutter={false}
            enableProse={false}
            className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl font-semibold mb-2 line-clamp-2 break-words text-black text-center"
          />
        )}

        {/* Description */}
        {service?.description ? (
          <RichText
            data={service.description}
            enableGutter={false}
            enableProse={false}
            className="text-sm sm:text-base md:text-lg text-muted-foreground mb-8 md:mb-12 lg:mb-9 line-clamp-5 break-words flex-1"
          />
        ) : (
          <div className="text-sm sm:text-base md:text-lg text-muted-foreground mb-8 md:mb-12 lg:mb-9 line-clamp-3 break-words flex-1">
            As the most experienced North DFW Area fence contractor,
          </div>
        )}
        <div className="space-y-3 mt-4">
          {service?.links?.map((item: any, linkIndex: any) => {
            const link = item.link
            return (
              <div
                key={linkIndex}
                // className="transform hover:translate-x-2 transition-transform duration-200"
              >
                <CMSLink
                  {...link}
                  className={cn(
                    `inline-flex items-center border border-border  text-primary-foreground cursor-pointer hover:text-primary-foreground font-semibold text-base tracking-wide transition-colors duration-300 group/link  rounded-full px-6 py-8 `,
                    btnClassName,
                  )}
                >
                  <div className="w-12 h-12 bg-primary rounded-full flex flex-1 items-center justify-center ml-2 group-hover/link:bg-primary">
                    <ChevronsRight />
                  </div>
                </CMSLink>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default StyleListServiceCard
